import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ChevronDown } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

gsap.registerPlugin(ScrollTrigger);

const FAQ = () => {
  const sectionRef = useRef(null);
  const accordionRef = useRef(null);

  const faqs = [
    {
      question: "Who can order from Doughnate?",
      answer: "We work with charities, schools, and community groups that raise funds for their own causes, but anyone who wants more than our minimum order quantity can order from us."
    },
    {
      question: "What is the minimum order?",
      answer: "5 boxes (20 doughnuts) per order."
    },
    {
      question: "Do you deliver?",
      answer: "Yes. Delivery and collection options are available depending on your location."
    },
        {
      question: "Do you offer additional incentives?",
      answer: "We operate on a shared-impact model that supports our charity partners beyond sales. For certain partnerships, we allocate a portion of our profits to be reinvested directly into their projects. Contact us to learn more about how we build these partnerships."
    }
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(accordionRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: accordionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const createSprinkleBurst = (element) => {
    const colors = ['#ec4899', '#14b8a6', '#fbbf24'];
    const rect = element.getBoundingClientRect();
    
    for (let i = 0; i < 5; i++) {
      const sprinkle = document.createElement('div');
      sprinkle.className = 'fixed w-2 h-2 rounded-full pointer-events-none z-50';
      sprinkle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      sprinkle.style.left = rect.right - 40 + 'px';
      sprinkle.style.top = rect.top + rect.height / 2 + 'px';
      document.body.appendChild(sprinkle);

      gsap.to(sprinkle, {
        x: Math.random() * 40 - 20,
        y: Math.random() * 40 - 20,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        onComplete: () => sprinkle.remove()
      });
    }
  };

  return (
    <section id="faqs" ref={sectionRef} className="py-20 px-4 bg-gradient-to-br from-pink-50 to-amber-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about Dough-nate
          </p>
        </div>

        <div ref={accordionRef}>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-2xl px-6 shadow-md hover:shadow-lg transition-all duration-300"
              >
                <AccordionTrigger
                  onClick={(e) => createSprinkleBurst(e.currentTarget)}
                  className="text-left font-semibold text-lg text-gray-900 hover:text-amber-600 transition-colors py-6"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;